import { fetchReleaseList } from './fetchReleaseList';
import { createDataObject } from './createDataObject';
import { isAllowedCachePageReload, removeAllLocalStorage, setLocalStorageWhenLeaving, storagedCacheNum } from './localStorage';
import { vmAddElement } from './components';

const $el = {
  body: document.body,
  addArea: document.querySelector('.js-readmore-add-area'),
  moreButtonWrap: document.querySelector('.js-list-article-more-wrap'),
  moreButton: document.querySelector('.js-list-article-more-button') || document.querySelector('.js-new-arrival-list-article-more-button'),
  inputTotalNum: document.querySelector('.js-list-total-num'),
  inputPageNum: document.querySelector('.js-list-page-num')
};

window.addEventListener('DOMContentLoaded', () => {
  if ($el.addArea !== null) {
    vmAddElement.$mount('.js-readmore-add-area');
  }
});

const releaseReadMore = () => {
  const config = {
    loadingFlg: false,
    pageNum: $el.inputPageNum.value,
    scrollTop: ''
  };

  const store = {
    page: 1,
    nextPage: 2
  };

  const getPageType = () => {
    const bodyClass = $el.body.getAttribute('class').split(' ')[0];
    switch (bodyClass) {
      case 'newrelease_list':
        return 'newarrival_db';
      case 'searchkey':
        return 'search';
      case 'top_category':
        return 'main_category';
      default:
        return '';
    }
  };

  function removeActiveFromMoreButton () {
    $el.moreButton.classList.remove('active');
  }

  function getTotalArticleCount () {
    return store.page * parseInt($el.inputPageNum.value, 10);
  }

  function makeMoreButtonDisabled () {
    $el.moreButton.setAttribute('disabled', true);
  }

  function makeMoreButtonEnabled () {
    $el.moreButton.setAttribute('disabled', false);
  }

  function addLoadingClassToMoreButtonLoading () {
    $el.moreButton.classList.add('is-loading');
  }

  function removeLoadingClassFromMoreButtonLoading () {
    $el.moreButton.classList.remove('is-loading');
  }

  function setLoadMoreButtonNextPageHref (nextPage) {
    $el.moreButton.setAttribute('href', nextPage);
  }
  function fetch (cacheFlg, cachePageNum) {
    const dataObject = createDataObject(getPageType(), store, config);
    makeMoreButtonDisabled();
    addLoadingClassToMoreButtonLoading();
    fetchReleaseList(dataObject).then(data => {
      store.page++;
      store.nextPage++;
      if (data.status.code !== 200) return false;
      data.articles.forEach(article => {
        vmAddElement.$data.value.push(article);
      });
      if (data.type === 'newarrival_db') {
        sendLatestGa($el.moreButton.getAttribute('href'));
        setLoadMoreButtonNextPageHref(data.next_page);
      }
      config.loadingFlg = false;
      makeMoreButtonEnabled();
      removeLoadingClassFromMoreButtonLoading();
      if (getTotalArticleCount() > data.searched.count) {
        removeActiveFromMoreButton();
      }
      if (cacheFlg && cachePageNum > store.page) {
        fetch(cacheFlg, cachePageNum);
      } else {
        if (localStorage.getItem('prev_page_url') && isAllowedCachePageReload()) {
          window.scrollTo(localStorage.getItem('scroll_top'));
        }
      }
    }).catch(err => {
      config.loadingFlg = false;
      makeMoreButtonEnabled();
      throw err;
    });
  }

  function sendLatestGa (url) {
    // eslint-disable-next-line
    ga('send', 'pageview', url);
  }

  function addEvent () {
    $el.moreButton.addEventListener('click', e => {
      e.preventDefault();
      if (!config.loadingFlg) {
        fetch();
      }
    });
    window.addEventListener('unload', function () {
      setLocalStorageWhenLeaving(isPageLatestOrSearch(), store.page);
    });
  }

  function isPageLatestOrSearch () {
    return getPageType() !== 'newarrival_db' && getPageType() !== 'search';
  }

  function handleCachePage () {
    if (isPageLatestOrSearch()) return false;
    if (isAllowedCachePageReload()) {
      fetch(true, storagedCacheNum);
    } else {
      removeAllLocalStorage();
    }
  }

  function isPageNumMoreThanTotalNum () {
    return parseInt($el.inputPageNum.value, 10) > parseInt($el.inputTotalNum.value, 10);
  }

  function init () {
    if (isPageNumMoreThanTotalNum()) {
      removeActiveFromMoreButton();
    }
    addEvent();
    handleCachePage();
  }

  init();
};

window.addEventListener('DOMContentLoaded', () => {
  if ($el.addArea && $el.moreButtonWrap) {
    releaseReadMore();
  }
});
